<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0" style="padding-left: 15px">
    <v-col>
      <div class="section-abstract-title">Coordonnées</div>
    </v-col>
  </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionAdresseExtend', 'salarie', false)">
      <v-col class="py-0">
        <div class="section-abstract-title"></div>
        <!-- A mettre ici pour Information non renseignée -->
        <div class="section-abstract-display">{{ adresseComplete }}
          <v-icon v-if="adresse.ville || adresse.adresse1 || adresse.codePostal"
                  class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                  @click.stop="copyText(adresseComplete, 10)">
            {{ copiedField === 10 ? 'fas fa-check' : 'fas fa-copy' }}
          </v-icon>
        </div>
        <div class="section-abstract-grid"
             style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">fas fa-chevron-right</v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionSalarieExtend', 'salarie', false)">
      <v-col>        
        <div class="section-abstract-grid"
             style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Adresse mail</div>
            <div class="section-abstract-value">{{ salarie.mail }}
              <v-icon v-if="salarie.mail" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(salarie.mail, 0)">
                {{ copiedField === 0 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Téléphone mobile</div>
            <div class="section-abstract-value">{{ salarie.numero }}
              <v-icon v-if="salarie.numero" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(salarie.numero, 1)">
                {{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">fas fa-chevron-right</v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import SectionSalarieCoordonneesAbstract from '@/generated/sections/SectionSalarieCoordonneesAbstract.vue';
  import Adresse from '@/extend/classes/Adresse';
  import { storeAdresse } from '@/generated/stores';

  export default defineComponent({
    extends: SectionSalarieCoordonneesAbstract,
    components: {},
    computed: {
      adresse(): Adresse {
        if (this.salarie && this.salarie.adresseId > 0) {
          return storeAdresse.getAdresse(this.salarie.adresseId);
        }
        return new Adresse();
      },
      adresseComplete(): string {
        const a = this.adresse;
        if (!a.adresse1 && !a.codePostal && !a.ville) {
          return "Adresse non renseignée";
        }
        return a.adresse1 + ', ' + a.codePostal + ', ' + a.ville;
      },
    },
  })
</script>
